<template>

	<div>

		<header id="header" :class="{ 'main': (pathname === '/') }" >
			<!-- header inner -->
			<div class="header">
				<h1 class="logo">
					<!--<a href="/"><img :src="coInfoVO.logo" alt="상상플렉스"></a>-->
					<!--<a href="/"><img :src="APIs.API_URL + '/coinfos/' + coInfoVO.coCode + '/logo'" v-if="coInfoVO.coCode != null" :alt="coInfoVO.coName"></a>-->
					<a href="/"><img :src="APIs.API_URL + '/coinfos/' + getCocode() + '/logo'" :alt="coInfoVO.coName"></a>
				</h1>
				<nav class="gnb">
					<ul class="depth1">
						<li v-for="d1 in gnbMenuList" :key="d1.code">
							<strong v-if="d1.menuLink && d1.menuLink !== 'javascript:;'"><a :href="d1.menuLink">{{ d1.menuName }}</a></strong>
							<strong v-else>{{ d1.menuName }}</strong>
							<ul class="depth2" v-if="d1.children && d1.children.length > 0">
								<li v-for="d2 in d1.children" :key="d2.code">
									<a :href="d2.menuLink || 'javascript:;'">{{ d2.menuName }}</a>
								</li>
							</ul>
							<ul class="depth2" v-else>
								<li><a href="javascript:;">&nbsp;</a></li>
							</ul>
						</li>
					</ul>
					<div class="bg" style="height: 190px;"></div>
				</nav>
				<div class="util">
					<ul class="user-menu" v-if="!isLogin()">
						<li><a href="javascript:;" @click="goLogin">로그인</a></li>
						<li><a href="/member/joinStart">회원가입</a></li>
					</ul>
					<ul class="user-menu" v-else-if="isLogin()">
						<li><a href="/mypage/">마이페이지</a></li>
						<li><a href="javascript:;" @click="doLogout">로그아웃</a></li>
					</ul>
					<div class="util-menu">
						<template v-if="isShowShopping">
							<a href="/app/shop/cartList" class="btn-cart" v-if="isLogin()"><span class="blind">장바구니</span></a>
							<a href="/member/login" class="btn-cart" v-else><span class="blind">장바구니</span></a>
						</template>
						<a href="/app/board/site_notice" class="btn-notice"><span class="blind">공지사항</span></a>
						<a href="javascript:;" class="btn-search"><span class="blind">검색</span></a>
						<a href="javascript:;" class="btn-sitemap"><span class="blind">전체메뉴 열기</span></a>
					</div>
				</div>

				<div class="util-mo" v-if="pathname !== '/'">
					<a href="javascript:history.back();" class="btn-back"><span class="blind">뒤로가기</span></a>
					<a href="/" class="btn-home"><span class="blind">홈</span></a>
				</div>

			</div>
			<!-- sitemap -->
			<div class="sitemap">
				<div class="panel">
					<div class="sitemap-panel-head">
						<a href="javascript:;" class="btn-close"><span class="blind">전체메뉴 닫기</span></a>
					</div>
					<div class="panel-scroll">
						<ul class="user-menu" v-if="!isLogin()">
							<li><a href="javascript:;" @click="goLogin">로그인</a></li>
							<li><a href="/member/joinStart">회원가입</a></li>
						</ul>
						<ul class="user-menu" v-else-if="isLogin()">
							<li><a href="/mypage/">마이페이지</a></li>
							<li><a href="javascript:;" @click="doLogout">로그아웃</a></li>
						</ul>
						<ul class="page-menu">
							<li v-for="d1 in gnbMenuList" :key="d1.code">
								<strong v-if="d1.menuLink && d1.menuLink !== 'javascript:;'"><a :href="d1.menuLink">{{ d1.menuName }}</a></strong>
								<strong v-else>{{ d1.menuName }}</strong>
								<ul class="depth2" v-if="d1.children && d1.children.length > 0">
									<li v-for="d2 in d1.children" :key="d2.code">
										<a :href="d2.menuLink || 'javascript:;'">{{ d2.menuName }}</a>
									</li>
								</ul>
							</li>
						</ul>
						<ul class="sns-link">
							<li>
								<a href="javascript:;" @click="snsOpen('https://www.youtube.com/channel/UCWUeeryencv7vO8QdtdL69g')" class="ico-youtube">
									<span class="blind">유튜브</span>
								</a>
							</li>
							<li>
								<a href="javascript:;" @click="snsOpen('http://pf.kakao.com/_GjtFK')" class="ico-kakao">
									<span class="blind">카카오 채널</span>
								</a>
							</li>
							<li>
								<a href="javascript:;" @click="snsOpen('https://band.us/band/83517670')" class="ico-band">
									<span class="blind">네이버 밴드</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="overlay"></div>
			</div>


			<!-- total search -->
			<div class="search headerSearch">
				<div class="panel">
					<h2>통합검색</h2>
					<div class="search-enter">
						<form @submit.prevent="doSearch(searchText)">

							<input class="inp-search" type="text" :placeholder="keywordVO.placeHolder" v-model="searchText">

							<button type="submit" class="btn-search" @click="closeSearch()">
								<span class="blind">search</span>
							</button>
						</form>
					</div>
					<div class="search-keyword">
						<strong>추천 검색어</strong>
						<ul>
							<li v-for="(item) in keywordList"><a href="javascript:;" @click="doSearch(item)">{{ item }}</a></li>
	<!--						<li><a href="javascript:;">Lumion</a></li>
							<li><a href="javascript:;">Revit애드인</a></li>
							<li><a href="javascript:;">BIM</a></li>
							<li><a href="javascript:;">RevitBOX</a></li>
							<li><a href="javascript:;">에너지박스</a></li>
							<li><a href="javascript:;">애드인</a></li>-->
						</ul>
					</div>
					<a href="javascript:;" class="btn-close"><span class="blind">전체메뉴 닫기</span></a>
				</div>
				<div class="overlay"></div>
			</div>


		</header>


		<!-- mobile nav -->
		<div id="mobileNav" class="mobile-nav">
			<div>
				<a href="/trend/newsfeeds" class="active">
					<i class="ico-trend"></i>
					<span>Trend</span>
				</a>
				<a href="/support-services/guide_function">
					<i class="ico-support"></i>
					<span>Support</span>
				</a>
				<a v-if="eduMenus.length > 0" :href="'/e-learning-services/' + eduMenus[0].code + '/' + eduMenus[0].codeName.replace(/ /gi, '_')">
					<i class="ico-learning"></i>
					<span class="txt-learning">E-Learning</span>
				</a>
				<a v-else href="/e-learning-services/200101/architecture">
					<i class="ico-learning"></i>
					<span class="txt-learning">E-Learning</span>
				</a>

				<template v-if="isShowShopping">
					<a href="/community/open">
						<i class="ico-community"></i>
						<span>Community</span>
					</a>
				</template>
				<template v-else>
					<a href="/app/board/site_notice">
						<i class="ico-community"></i>
						<span>Notice</span>
					</a>
				</template>

				<template v-if="isLogin()">
					<a href="/mypage/">
						<i class="ico-mypage"></i>
						<span>My Page</span>
					</a>
				</template>
				<template v-else>
					<a href="/member/login">
						<i class="ico-mypage"></i>
						<span>My Page</span>
					</a>
				</template>
			</div>
		</div>
		<!-- //mobile nav -->

	</div>





</template>


<script>

import HWAPP from '@/commons/mixins/hwapp.mixin'
import webUtils from "@/commons/utils/web.utils";
import $ from "../../../public/common/jquery/jquery-3.4.1";


export default {
	name: "partialHeader",
	mixins: [
		HWAPP
	],
	data() {


		return {

			pathname: location.pathname,

			coInfoVO: new this.CoInfo(),
			keywordVO: new this.KeywordVO(),
			keywordList: [],

			searchText: "",

			gnbMenuList: [],
			/** 공통코드 2001(교육 분야) 하위 — 모바일 E-Learning 단축 링크 등에 사용 */
			eduMenus: [],

			isShowShopping: true,
			isShowSnsLogin: true,

		}
	},
	beforeCreate() {
		let self = this

		window.onload = function() {
			// if (location.hash.length > 0) {
			// 	try {
			// 		// hex code to string
			// 		const htos = (s) => {
			// 			let j
			// 			let h = s.match(/.{1,4}/g) || []
			// 			let b = ""
			// 			for(j = 0; j < h.length; j++) { b += String.fromCharCode(parseInt(h[j], 16)) }
			// 			return b
			// 		}
			//
			// 		self.$session.set("HWSSessions", decodeURI(htos(atob(location.hash.replace("#", "")))))
			// 		history.replaceState("", document.title, window.location.pathname + window.location.search)
			// 		location.reload()
			// 		// eslint-disable-next-line no-empty
			// 	} catch (e) {
			// 	}
			// }

			window.addEventListener('message', event => {
				let allowOrigin = event.origin

				if (event.data.caidx != null) {
					allowOrigin = allowOrigin.replace(webUtils.getSubdomain(), event.data.coCode)

					if (event.origin === new URL(allowOrigin).origin) {
						self.$session.set("HWSSessions", event.data)
					}
				}

				if (event.data.key === "alert") {
					self.swalUtils.gritter(event.data.title, event.data.content,  event.data.icon, 1500)
				}

				if (event.data.key === "go") {
					location.href = event.data.to
				}

				if (event.data.key === 'apple') {
					self.$session.set("HWSSessions", event.data.account)
					self.goWithCoCode(self)
				}
			}, false);
		}
	},
	async created() {

		this.getCompanyInfo();
		this.getKeywords();
		await this.loadGnbFromCode50();

		this.eduMenus = []
		const eduCodeVO = await this.getCodeOne("2001");
		if (eduCodeVO && eduCodeVO.children) {
			eduCodeVO.children.forEach((child) => {
				this.eduMenus.push({
					code: child.code,
					codeName: child.codeName,
				})
			})
		}

		/**
		 * google analytics
		 */
		// <!-- Google tag (gtag.js) -->
		this.$loadScript("https://www.googletagmanager.com/gtag/js?id=G-893ZD679HL").then(() => {
			console.log('https://www.googletagmanager.com/gtag/js?id=G-893ZD679HL')
			window.dataLayer = window.dataLayer || [];
			function gtag(){window.dataLayer.push(arguments);}
			gtag('js', new Date());

			gtag('config', 'G-893ZD679HL');
		})


	},
	mounted() {



	},
	methods: {
		snsOpen(url) {
			const temp = {
				isCloseBTN : "Y",
				url: url,
			}
			this.appOpen( temp );
		},

		async getCompanyInfo() {

			var self = this

			self.coInfoVO = await self.getCoInfoVO()
			if (self.coInfoVO.logo == null) {
				self.coInfoVO.logo = "/assets/img/temp/temp_logo.svg";
			}

			// 아이폰이 경우 사이트 설정 따라가게 설정
			if (self.appDevice() === "IOS") {
				self.isShowShopping = self.coInfoVO.isIosShop
				self.isShowSnsLogin = self.coInfoVO.isIosSns
			}

			/*this.axiosCaller.get(this, this.APIs.CO_INFO + "/" + this.webUtils.getSubdomain(), {}, (res) => {
				const result = res.data
				if (result.status === "ok") {
					self.coInfoVO = result.coInfoVO
					if (self.coInfoVO.logo == null) {
						self.coInfoVO.logo = "/assets/img/temp/temp_logo.svg";
					}
					console.log(self.coInfoVO)
				} else {
					console.log(result.msg)
				}
			})*/
		},


		/** 공통코드 50번(CodeVO) 직계 자식 → GNB 1차, 각 항목의 children → 2차. isUse=false 는 제외 */
		gnbCodeIsActive(vo) {
			if (vo == null) return false;
			const u = vo.isUse;
			if (u === false || u === 0 || u === "0" || u === "false" || u === "N") return false;
			return true;
		},
		mapGnbNode(vo) {
			const link = (vo.menuLink && String(vo.menuLink).trim() !== "") ? vo.menuLink : "javascript:;";
			return {
				code: vo.code,
				menuName: vo.codeName,
				menuLink: link,
				children: []
			};
		},
		async loadGnbFromCode50() {
			const GNB_ROOT = "50";
			try {
				const root = await this.getCodeOne(GNB_ROOT);
				const raw = root && root.children ? root.children : [];
				const depth1 = [];
				for (const n of raw) {
					if (!this.gnbCodeIsActive(n)) continue;
					const d1 = this.mapGnbNode(n);
					if (n.children && n.children.length) {
						d1.children = n.children
							.filter((c) => this.gnbCodeIsActive(c))
							.map((c) => this.mapGnbNode(c));
					}
					depth1.push(d1);
				}
				this.gnbMenuList = depth1;
			} catch (e) {
				console.warn("GNB(코드50) 로드 실패", e);
				this.gnbMenuList = [];
			}
		},

		getKeywords () {

			var self = this
			this.axiosCaller.get( this, this.APIs.DP_KEYWORD + "/search_all", {}, (res) => {
				const result = res.data
				console.log( result )
				if ( result.status === "ok" ) {
					if ( result.keywordVO != null ) {
						self.keywordVO = result.keywordVO
						self.keywordList = self.keywordVO.keywords.split(",")
						if ( self.keywordVO.searchOption === 'V' ) {
							self.searchText = self.keywordVO.inputValue
						}
					}
				} else {
					console.log( result.msg )
				}
			})

		},


		doSearch (_searchText) {

			this.searchText = _searchText
			if (_searchText.length === 0) {
				this.swalUtils.fire("검색어를 입력해 주세요.", "", "question")
			} else {
				webUtils.goTo(this, `/app/searcher/${this.stringUtils.toBase64(this.searchText)}`)
			}
		},

		closeSearch(){
			$(".headerSearch").stop().fadeOut();
		},



	},
}
</script>

<style scoped>

</style>
